export const questionData = [
  {
    title: "Basic Details",
    questions: [
      { id: 1, question: "What's your full name?", type: "text" },
      { id: 2, question: "How old are you?", type: "number" },
      {
        id: 3,
        question: "How do you identify your gender?",
        type: "select",
        options: ["Male", "Female", "Prefer not to say", "Other"],
      },
      {
        id: 4,
        question: "Which area/locality do you live in?",
        type: "checkbox",
        // Note: Options will be populated dynamically based on selected city
        // See CITY_LOCALITIES in googleForm.config.ts
        options: [
          "Shivajinagar",
          "Kothrud",
          "Hadapsar",
          "Camp",
          "Hinjewadi",
          "Viman nagar",
          "Peth",
          "Baner",
          "PCMC",
          "Other",
        ],
      },
      {
        id: 5,
        question: "WhatsApp Number",
        type: "number",
      },
      { id: 6, question: "What's your Instagram handle?", type: "text" },
    ],
  },
  {
    title: "Dating Preferences",
    questions: [
      {
        id: 7,
        question: "Who would you like to be matched with?",
        type: "select",
        options: ["Male", "Female", "Other"],
      },
      {
        id: 8,
        question: "Preferred age range for your match",
        type: "text",
      },
      {
        id: 9,
        question: "Which days work best for you for a date?",
        type: "checkbox",
        options: ["Weekend", "Weekday", "Both"],
      },
      {
        id: 10,
        question: "What time do you prefer for a date?",
        type: "checkbox",
        options: ["Daytime", "Nighttime", "Both works"],
      },
      {
        id: 11,
        question: "What type of date do you enjoy most?",
        type: "checkbox",
        options: [
          "Coffee Date ☕",
          "Dinner Date 🍽️",
          "Activity Date 🎳",
          "Surprise Me 🎁",
        ],
      },
      {
        id: 12,
        question: "What’s your comfortable spending range for a date?",
        type: "select",
        options: ["0", "0–500", "500–1000", "1000–2000", "2000+"],
      },
    ],
  },
  {
    title: "Personality and Lifestyle",
    questions: [
      { id: 13, question: "What’s your current occupation?", type: "text" },
      {
        id: 14,
        question: "Tell us a few of your hobbies or interests",
        type: "text",
      },
      {
        id: 15,
        question:
          "On a scale of 1 (Introvert) to 5 (Extrovert), how would you describe yourself?",
        type: "scale",
        options: ["1", "2", "3", "4", "5"],
      },
      {
        id: 16,
        question: "Do you smoke?",
        type: "select",
        options: ["Yes", "No"],
      },
      {
        id: 17,
        question: "Do you drink alcohol?",
        type: "select",
        options: ["Yes", "No", "Occasionally"],
      },
      {
        id: 18,
        question: "How do you feel about pets?",
        type: "select",
        options: ["Love them", "Indifferent", "Allergic"],
      },
    ],
  },
  {
    title: "Compatibility Insights",
    questions: [
      {
        id: 19,
        question: "Three words your friends would use to describe you",
        type: "text",
      },
      {
        id: 20,
        question: "What’s a green flag for you in someone you’re dating?",
        type: "textarea",
      },
      {
        id: 21,
        question: "What’s a red flag or dealbreaker for you?",
        type: "textarea",
      },
      {
        id: 22,
        question:
          "Would you date someone from a different religion, caste, or language?",
        type: "select",
        options: ["Yes", "No", "Maybe", "Other"],
      },
    ],
  },
  {
    title: "Confirm Your Participation",
    questions: [
      {
        id: 23,
        question: "Please confirm your understanding and agreement",
        type: "checkbox",
        options: [
          "I understand this is a blind date",
          "I’m over 18 and legally allowed to date.",
          "I agree to pay ₹499 (female)/ ₹999 (male) to book the experience when matched. Express date charges extra.",
          "I’ll be respectful and open-minded on the date.",
          "I understand that refunds are not guaranteed.",
          "I confirm that I am 18+ and I have read and agree to the Privacy Policy and consent to the collection and use of my personal information as described.",
        ],
      },
    ],
  },
];
